export const DAY_MS = 86_400_000;

/** epoch 이래 누적 UTC 일수 (UTC 자정 경계 인덱스). Pure. */
export function utcDayIndex(at: number = Date.now()): number {
  return Math.floor(at / DAY_MS);
}

/** from~to 사이에 넘은 UTC 자정 경계 수 (= UTC 날짜 차). */
export function utcDayDiff(fromMs: number, toMs: number): number {
  return utcDayIndex(toMs) - utcDayIndex(fromMs);
}

/** start 가 속한 UTC 날짜로부터 durationDays 번째 날짜의 시작(자정) epoch ms. */
export function utcDayExpiry(startMs: number, durationDays: number): number {
  return (utcDayIndex(startMs) + durationDays) * DAY_MS;
}

/** Returns the UTC date (YYYY-MM-DD) for the given instant (default: now). Pure. */
export function getTodayUTC(at: Date | number = Date.now()): string {
  const d = at instanceof Date ? at : new Date(at);
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

/** Returns epoch-ms for the next UTC midnight after the given instant (default: now). */
export function getNextUtcMidnight(at: Date | number = Date.now()): number {
  const d = at instanceof Date ? at : new Date(at);
  return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 1);
}

/** True if the YYYY-MM-DD date string equals the UTC date of the given instant (default: now). */
export function isDateToday(dateStr: string, at: Date | number = Date.now()): boolean {
  return dateStr === getTodayUTC(at);
}

/**
 * ISO-8601 문자열을 절대 epoch ms 로 변환한다.
 * 오프셋(`Z` 또는 `±HH:MM`)이 반드시 있어야 한다 — naive 문자열은 실행 머신
 * 로컬 TZ 로 해석돼 빌드 머신마다 결과가 갈리므로 명시적으로 거부한다.
 */
export function parseIsoToEpochMs(s: string): number {
  if (!/(?:Z|[+-]\d{2}:\d{2})$/.test(s)) {
    throw new Error(`parseIsoToEpochMs: missing timezone offset in "${s}" (use +09:00 or Z)`);
  }
  const ms = Date.parse(s);
  if (Number.isNaN(ms)) throw new Error(`parseIsoToEpochMs: unparseable date "${s}"`);
  return ms;
}
